<template>
  <input type="file" @input="$emit('input', $event.target.files[0])">
</template>

<script>
export default {
  name: "FormFile"
}
</script>

<style scoped>

</style>
